// Every chart in the app opens on 20 May 2026.
//
// The first CaryPact imports reach back to 7 May, but those days are partial —
// wallets were connected mid-stream — so a chart that starts there opens on a
// ragged tail that reads like a slump instead of history. Tables, KPI tiles and
// totals still count every single day.
export const CHART_START = "2026-05-20";

export const sinceChartStart = (rows, key = "date") =>
  (rows || []).filter((r) => String((r && r[key]) || "") >= CHART_START);

export const chartStart = (date) => (date && date < CHART_START ? CHART_START : date);

/** The day a combined chart should end on.
 *
 *  It used to end at the EARLIEST last-day among the streams, to dodge the one-day
 *  cliff you get when team rewards import a day behind mining. The cost was far
 *  worse than the cure: one wallet whose CaryPact session expired on 24 Sep hid
 *  every other wallet's October, and the whole account read as dead. So: end on the
 *  NEWEST day anything in the selection actually reported. A quiet wallet adds
 *  nothing after its last day, which leaves the running total flat rather than
 *  dipping — money already earned never disappears.
 *
 *  Today is always a partial day, so the range stops at yesterday. The end is never
 *  padded past real data: if nothing reported for a week, the chart ends a week ago.
 */
export function chartEndDay(lastReportedDay, today) {
  const end = lastReportedDay || today;
  if (!end) return null;
  if (end < today) return end;
  const y = new Date(`${today}T00:00:00Z`);
  y.setUTCDate(y.getUTCDate() - 1);
  return y.toISOString().slice(0, 10);
}

/** Wallets far enough behind the rest of a selection to be worth naming.
 *  Three days' grace, so ordinary sync timing never trips it. Oldest silence first,
 *  because that's the one he should chase. */
export function walletsBehind(lastByWallet, newestDay, graceDays = 3) {
  if (!newestDay) return [];
  const day = (d) => Date.parse(`${String(d).slice(0, 10)}T00:00:00Z`);
  return Object.entries(lastByWallet || {})
    .filter(([, last]) => last && Math.round((day(newestDay) - day(last)) / 86400000) >= graceDays)
    .map(([id, last]) => ({ id, last }))
    .sort((a, b) => a.last.localeCompare(b.last));
}
